// extracted by mini-css-extract-plugin
export var addToCartButton = "_k3-b";
export var arrowButtonContainer = "_k3-9";
export var arrowButtonIcon = "_k3-a";
export var carouselArrowButton = "_k3-6";
export var carouselElementContainer = "_k3-1";
export var left = "_k3-7";
export var productDisplayCarouselContainer = "_k3-0";
export var productTileContainer = "_k3-2";
export var productTileImage = "_k3-4";
export var productTileImageContainer = "_k3-3";
export var productTileTitle = "_k3-5";
export var right = "_k3-8";
export var sliderOverflow = "_k3-c";